<template>
  <div>
    <vx-card  v-can="'view-staff'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row mb-3">
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-100 text-bold">Name</label>

        <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="mb-4 md:mb-0 w-full"/>
      </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Email</label>

          <vs-input type="search"  placeholder="Search.." v-model="filters['email']" class="mb-4 md:mb-0 w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Status</label>
          <v-select name="status" :clearable="false"
            v-model="filters['is_active']" :options="statusOptions"  :reduce="option => option.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"
            label="name" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Contact Number</label>
          <vs-input type="search"  placeholder="Search.." v-model="filters['contact_1']" class="mb-4 md:mb-0 w-full"/>
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-100 text-bold">MFA</label>
              <div class="vx-row">
                <div class="vx-col w-1/5 mt-2 text-sm">
                  <span :class="`${filters['is_google_2fa_enable'] ? '' : 'text-primary'}`">All users</span>
                </div>
                <div class="vx-col w-1/5 ml-0">
                  <vs-switch v-model="filters['is_google_2fa_enable']" class="mt-2"/>
                </div>
                <div class="vx-col w-3/5 mt-2 text-sm ml-0">
                  <span :class="`${filters['is_google_2fa_enable'] ? 'text-primary' : ''}`">MFA Enabled</span>
                </div>
              </div>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-100 text-bold">Account Handlers</label>
              <div class="vx-row">
                <div class="vx-col w-1/5 mt-2 text-sm">
                  <span :class="`${filters['is_account_handler'] ? '' : 'text-primary'}`">All Users</span>
                </div>
                <div class="vx-col w-1/5 ml-0">
                  <vs-switch v-model="filters['is_account_handler']" class="mt-2"/>
                </div>
                <div class="vx-col w-3/5 mt-2 text-sm ml-0">
                  <span :class="`${filters['is_account_handler'] ? 'text-primary' : ''}`">Handlers Only</span>
                </div>
              </div>
          </div>
      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                      color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
  <div class="vx-row">

    <div class="vx-col w-full">
      <vx-card title="STAFF" v-can:any="['create-edit-staff', 'view-staff']">
        <template slot="actions">
            <vs-button v-can="'create-edit-staff'" @click="onClickCreateStaff" class="mr-4" color="primary" type="filled">Create User</vs-button>
        </template>
        <div slot="no-body" class="mt-4">
          <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                    v-model="filters['search']"
                    class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
          <vs-table v-can="'view-staff'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"  @sort="handleSort"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

            <template slot="thead">
              <vs-th sort-key="name">NAME</vs-th>
              <vs-th>ACCOUNT OWNER</vs-th>
              <vs-th sort-key="email">EMAIL</vs-th>
              <vs-th sort-key="contact_1">CONTACT</vs-th>
              <vs-th>LAST LOGGED IN</vs-th>
              <vs-th class="text-center">STATUS</vs-th>
              <vs-th class="float-left">USER</vs-th>
              <vs-th>2FA</vs-th>
              <vs-th style="min-width: 175px;" v-can="'create-edit-staff'">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr  :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td>
                  <!-- <vx-tooltip v-if="data[indextr].is_account_handler" text="Account Manager">
                    <vs-button icon-pack="feather" icon="icon-shield" color="primary" size="small"></vs-button>
                  </vx-tooltip > -->
                  <vs-chip v-if="data[indextr].is_account_handler" transparent color="primary">
                    Yes
                  </vs-chip>
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ data[indextr].email }}
                </vs-td>
                <vs-td :data="data[indextr].contact_1">
                  {{ data[indextr].contact_1 }}
                </vs-td>

                <vs-td :data="data[indextr].last_login_at">
                  <span v-if="data[indextr].email_verified_at">
                    {{ __dateTimeFormatter(data[indextr].last_login_at) }}
                  </span>
                  <span v-if="!data[indextr].email_verified_at && !data[indextr].is_active" class="text-danger">
                    Invite sent {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </span>
                </vs-td>

                <vs-td :data="data[indextr].is_active">
                  <vs-chip transparent v-if="data[indextr].is_active"  color="primary">
                    Active
                  </vs-chip>
                  <vs-chip transparent v-if="!data[indextr].is_active"  color="danger">
                    {{ data[indextr].email_verified_at ? 'Inactive' : 'Pending Verification' }}
                  </vs-chip>
                </vs-td>

                <vs-td :data="data[indextr].role">
                  {{ !!data[indextr].role ? data[indextr].role.name : ''}}
                </vs-td>

                <vs-td>
                  <vs-chip v-if="data[indextr].is_google_2fa_enable" transparent color="dark">
                    Enabled
                  </vs-chip>
                </vs-td>

                <vs-td v-can="'create-edit-staff'">
                  <div class="flex items-center">
                    <vx-tooltip class="mr-2" text="Edit" position="left">
                      <vs-button @click.stop="onClickUserEdit(data[indextr].id)"
                                 size="small" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="mr-2" text="Mobile App Security" position="left">
                      <vs-button @click.stop="onClickMobileSecurity(data[indextr])"
                                 size="small" color="#5E50EE" type="border" icon-pack="feather" icon="icon-smartphone"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip v-if="!data[indextr].email_verified_at" class="mr-2" text="Resend welcome email" position="left">
                      <vs-button @click.stop="onClickResendWelcomeEmail(data[indextr].email)"
                                 size="small" color="#4AA96C" type="border" icon-pack="feather" icon="icon-refresh-ccw"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip v-if="data[indextr].is_active === 1 && data[indextr].id !== $store.getters.currentUser.id" class="mr-2" text="De-Activate User" position="left">
                      <vs-button @click.stop="onClickDeActiveUser(data[indextr].id)"
                                 size="small" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip v-if="data[indextr].is_active === 0 && data[indextr].id !== $store.getters.currentUser.id" class="mr-2" text="Activate User" position="left">
                      <vs-button @click.stop="onClickActiveUser(data[indextr].id)"
                                 size="small" color="success" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>


          </vs-table>
<!--          <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>-->
          <vs-pagination
            v-on:changeMaxItems="changePage"
            :size-array="meta.total ? meta.total : 20"
            :max-items="perPage"
            description-body="Rows per page"
            description-connector="of"
            description-title="Records"
            description
            :description-items="descriptionItems"
            :total="(meta.last_page)? meta.last_page : 0"
            v-model="page"  class="p-5">
          </vs-pagination>
        </div>
      </vx-card>
    </div>
  </div>
    <update-staff-pop-up ref="trackingImages"/>
    <create-staff-pop-up ref="createStaffPopup"/>
    <staff-mobile-security-pop-up ref="mobileSecurityPopup"/>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import UpdateStaffPopUp from '@/components/popups/staff/UpdateStaffPopUp'
import CreateStaffPopUp from '@/components/popups/staff/CreateStaffPopUp'
import StaffMobileSecurityPopUp from '@/components/popups/staff/StaffMobileSecurityPopUp'
const StaffRepository = RepositoryFactory.get('staff')
const DepartmentsRepository = RepositoryFactory.get('departments')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import {defaultPagination, perPageList} from "@/constants/config";

export default {
  name: 'AllUsersList',
  data () {
    return {
      selected: [],
      updateStaffSelected: [],
      options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
      popupActive: false,
      createUserPopupActive: false,
      popUpTitle: '',
      editActive: false,
      edit: null,
      editProp: {},
      checkBox1: false,
      activeConfirm: false,
      staff: [],
      selectedStaff: {},
      createStaffForm: {},
      departments: [],
      users: [],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      statusOptions: [
        {
          name: 'Active',
          value: '1'
        }, 
        {
          name: 'Inactive',
          value: '0'
        }
      ]
    }
  },
  components: {
    'v-select': vSelect,
    UpdateStaffPopUp,
    CreateStaffPopUp,
    StaffMobileSecurityPopUp
  },
  async mounted () {
    // this.$refs.filterCard.isContentCollapsed = true
    // this.$refs.filterCard.maxHeight = '1.5rem'
    // await this.loadDepartments()
  },
  methods: {
    async refreshData () {
      this.loadStaff()
    },

    async onClickUserEdit (id) {
      await this.$refs.trackingImages.openPopup(id)
    },
    onClickMobileSecurity (staffUser) {
      if (this.$refs.mobileSecurityPopup) {
        this.$refs.mobileSecurityPopup.openPopup(staffUser)
      }
    },
    async onClickResendWelcomeEmail(email) {
      this.$vs.loading()
      try {
        await StaffRepository.resendWelcomeEmail(email)
        this.showSuccessMessage('Email resent successfully')
      }catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async onClickDeActiveUser(id) {
      this.$vs.loading()
      try {
        await StaffRepository.deActiveStaffUser(id)
        this.showSuccessMessage('User De-Activated successfully')
        await this.loadStaff()
      }catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async onClickActiveUser(id) {
      this.$vs.loading()
      try {
        await StaffRepository.activeStaffUser(id)
        this.showSuccessMessage('User Activated successfully')
        await this.loadStaff()
      }catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async loadDepartments() {
      this.$vs.loading()
      try {
        const {data} = await DepartmentsRepository.get(' ', '', '', '' )
        this.departments =  data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },

    async loadStaff() {
      this.$vs.loading()
      try {
        const {data} = await StaffRepository.get(this.page, this.filterQuery, this.perPage, this.sort)
        this.staff =  data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },

    async onClickCreateStaff () {
      await this.$refs.createStaffPopup.openPopup()
    },

    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },

    openConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Remove Confirm',
        text: 'Are you sure you want to permanently remove this organization?',
        accept: this.acceptAlert
      })
    },

    acceptAlert () {
      this.$vs.notify({
        color: 'danger',
        title: 'Deleted Organization',
        position:'top-right',
        text: 'The selected organization was successfully deleted'
      })
    },

    filterQueryUpdate (){
      this.loadStaff()
    },

    handleChangePage(page) {
      this.page=page;
      this.loadStaff()
    },

    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.loadStaff()
      }

    }

  },
  watch : {
    page(){
      this.loadStaff()
    },
    perPage() {
      this.loadStaff()
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
